<template>
    <VoMenyy>
        <template #elemendid>
            <template v-for="(item, i) in menuItems" :key="i">
                <VoMenyyElement v-if="item.route && !item.condition || (item.condition && item.condition())"
                    :pealkiri="item.title" :vaartus="item.value" :keelatud="!item.route" :ikoon="item.icon"
                    :url="item.route" />
            </template>
        </template>
        <template #kasutaja>
            <KasutajaInfo></KasutajaInfo>
        </template>
    </VoMenyy>    
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import menuItems from '../../data/menuu';
import KasutajaInfo from "./KasutajaInfo.vue"

interface menuItem {
    icon: string,
    title: string,
    value: string,
    route?: string,
    condition?(): boolean,
}

export default defineComponent({
    name: 'PeaMenuu',
    components: { KasutajaInfo },
    data() { return { menuItems: menuItems as menuItem[] }; },
});
</script>